import { ITranslateProps, InjectedFormProps } from 'models/common';
import * as React from 'react';
import { translate } from 'react-i18next';
import { IStore } from 'redux/IStore';
const { connect } = require('react-redux');
import * as c from 'models/constants';
import { reduxForm, Field } from 'redux-form';
import { PortalPageSection } from 'components/PortalStructure';
import { getShopSmsCount } from 'redux/modules/subscriptionplans/shopsubscriptionplans';
import { IShopSubscriptionPlan, IShopSubscriptionPlanPost, IShopSubscriptionPlanPut } from 'models/subscriptionplans';
import { BookingDatePicker } from 'components/FormControls';
import moment = require('moment');

require('./style.scss');

interface IOwnProps {
	shopId: string;
	shopSubscriptionPlan?: IShopSubscriptionPlan;
	isNewSubscription?: boolean;

	onCancelNew?: () => void;
	onFinish?: () => void;
}

type FormData = {
	[key: string]: Partial<IShopSubscriptionPlanPost & IShopSubscriptionPlanPut>;
};

interface IProps
	extends InjectedFormProps<FormData>,
		IOwnProps,
		ReturnType<typeof mapStateToProps>,
		ReturnType<typeof mapDispatchToProps>,
		ITranslateProps {}

interface IState {
	smsUsedInTimeframe: number;
}

const mapStateToProps = (state: IStore) => {
	let currentFormValues = null;

	if (state.form[c.FORM_NAME_SMS_INTERVAL_PICKER] && state.form[c.FORM_NAME_SMS_INTERVAL_PICKER].values) {
		currentFormValues = state.form[c.FORM_NAME_SMS_INTERVAL_PICKER].values;
	}

	return {
		manageShop: state.manageShop,
		shopSubscriptionPlans: state.shopSubscriptionPlansReducer,
		currentFormValues,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getShopSmsCount: (shopId: string, dateValues: any): Promise<any> => dispatch(getShopSmsCount(shopId, dateValues)),
});

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class AdminSmsIntervalPickerForm extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			smsUsedInTimeframe: 0,
		};
	}

	componentDidUpdate(prevProps: Readonly<IProps>): void {
		if (
			JSON.stringify(prevProps?.currentFormValues) !== JSON.stringify(this.props?.currentFormValues) &&
			this.props?.currentFormValues?.dateFrom &&
			this.props?.currentFormValues?.dateTo
		) {
			this.props
				.getShopSmsCount(this.props.manageShop.shop.id, {
					dateFrom: this.props.currentFormValues.dateFrom,
					dateTo: moment(this.props.currentFormValues.dateTo).endOf('day').toISOString(),
				})
				.then((data) => {
					this.setState({ smsUsedInTimeframe: data.total });
				})
				.catch((e) => console.error(e));
		}
	}

	public render() {
		const { t } = this.props;

		return (
			<PortalPageSection>
				<form>
					<h3 className="adminSmsIntervalPicker__sms-title">{t('Admin_AdminSubscriptionPlans_SmsTitle')}</h3>

					<div className="adminSmsIntervalPicker__date-fields">
						<div className="row">
							<div className="col-sm-6">
								<Field
									name={`dateFrom`}
									component={BookingDatePicker}
									type="text"
									label={t('Admin_ShopSubscriptionPlans_Field_ValidFrom')}
									information={t('Admin_ShopSubscriptionPlans_Field_ValidFrom')}
								/>
							</div>
							<div className="col-sm-6">
								<Field
									name={`dateTo`}
									component={BookingDatePicker}
									type="text"
									label={t('Admin_ShopSubscriptionPlans_Field_ValidTo')}
									information={t('Admin_ShopSubscriptionPlans_Field_ValidTo')}
									minDate={new Date(this.props?.currentFormValues?.dateFrom) || undefined}
								/>
							</div>
						</div>
					</div>

					{this.props.currentFormValues?.dateFrom && this.props.currentFormValues?.dateTo ? (
						<div className="adminSmsIntervalPicker__sms-used">
							{t('Admin_AdminSubscriptionPlans_SmsUsed')} {this.state?.smsUsedInTimeframe}
						</div>
					) : null}
				</form>
			</PortalPageSection>
		);
	}
}

let AdminSmsIntervalPicker = reduxForm({
	form: c.FORM_NAME_SMS_INTERVAL_PICKER,
	enableReinitialize: true,
})(AdminSmsIntervalPickerForm);

AdminSmsIntervalPicker = connect(mapStateToProps, mapDispatchToProps)(AdminSmsIntervalPicker);

export { AdminSmsIntervalPicker };
